module.exports = __webpack_public_path__ + "img/pressure.c4bd3323.svg";